import { isLiteTemplate } from "@lexicanon/shared"
import type { I18n } from "@lingui/core"
import { msg } from "@lingui/core/macro"
import { displayMeetingTitle } from "../../lib/meeting-title"
import { starterKey, type TStarterQuestion } from "./starters"

export interface IStarterLabel {
  id: string
  label: string
}

/** A meeting row's fields the starter titles need. Matches the list payload. */
export interface IStarterMeeting {
  subject?: string | null
  topics?: string[] | null
  template_id?: string | null
  start_time?: string | null
}

/** Human titles, newest first, for {@link buildStarterQuestions}. */
export function titlesForStarters(meetings: readonly IStarterMeeting[], i18n: I18n): string[] {
  return meetings.map((meeting) =>
    displayMeetingTitle(meeting.subject, meeting.topics, i18n, {
      lite: isLiteTemplate(meeting.template_id),
      startedAt: meeting.start_time,
    }),
  )
}

/** English source text for a starter. `msg` literals so Lingui can extract each. */
export function formatStarterQuestion(i18n: I18n, starter: TStarterQuestion): string {
  switch (starter.kind) {
    case "decided-this-week":
      return i18n._(msg`What did we decide this week?`)
    case "open-actions":
      return i18n._(msg`Which action items are open for me?`)
    case "session-recap":
      return i18n._(msg`What happened in our last session?`)
    case "open-quests":
      return i18n._(msg`Which quests are still open?`)
    case "summarise":
      return i18n._(msg`Summarise ${starter.title}.`)
    case "came-up":
      return i18n._(msg`What came up in ${starter.title}?`)
  }
}

export function labelStarters(starters: readonly TStarterQuestion[], i18n: I18n): IStarterLabel[] {
  return starters.map((starter) => ({
    id: starterKey(starter),
    label: formatStarterQuestion(i18n, starter),
  }))
}
